/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(['backbone'], function(backbone) {
    return backbone.Model.extend({
        defaults: {
            /** @var StartFileModel startFile */
            startFile: null,

            /** @var ProductModel product */
            product: null,

            products: []
        }
    });
});
